// Smooth Header Add to Cart with height animations
function initHeaderProductCart() {
   

    const headerCartContainer = document.querySelector('.header-add-to-cart');
    const productInfoElement = document.querySelector('product-info');
    
    if (!headerCartContainer || !productInfoElement) {
        return;
    }

    let isHeaderCartVisible = false;

    // Function to check if product-info is out of view
    function checkProductInfoVisibility() {
        const rect = productInfoElement.getBoundingClientRect();
        const isOutOfView = rect.bottom < 0; // Product info has scrolled above viewport
        
        if (isOutOfView && !isHeaderCartVisible) {
            showHeaderCart();
            isHeaderCartVisible = true;
        } else if (!isOutOfView && isHeaderCartVisible) {
            hideHeaderCart();
            isHeaderCartVisible = false;
        }
    }

    // Show header cart with smooth drop-down animation
    function showHeaderCart() {
        const isAvailable = updateHeaderProductDetails();
        
        if (!isAvailable) {
            return;
        }
        
        // Initial state: set up for animation
        headerCartContainer.style.display = 'block';
        headerCartContainer.style.height = '0px';
        headerCartContainer.style.overflow = 'hidden';
        headerCartContainer.classList.add('opacity-0', 'transform', '-translate-y-4');
        
        // Force a reflow
        headerCartContainer.offsetHeight;
        
        // Get the natural height
        headerCartContainer.style.height = 'auto';
        const naturalHeight = headerCartContainer.scrollHeight;
        headerCartContainer.style.height = '0px';
        
        // Start the animation
        requestAnimationFrame(() => {
            headerCartContainer.classList.add('transition-all', 'duration-500', 'ease-out');
            headerCartContainer.style.height = naturalHeight + 'px';
            headerCartContainer.classList.remove('opacity-0', '-translate-y-4');
            headerCartContainer.classList.add('opacity-100', 'translate-y-0');
            
            // Clean up after animation
            setTimeout(() => {
                headerCartContainer.style.height = 'auto';
                headerCartContainer.style.overflow = 'visible';
                headerCartContainer.classList.add('visible');
            }, 500);
        });
    }

    // Hide header cart with smooth slide-up animation
    function hideHeaderCart() {
        // Get current height for smooth collapse
        const currentHeight = headerCartContainer.scrollHeight;
        headerCartContainer.style.height = currentHeight + 'px';
        headerCartContainer.style.overflow = 'hidden';
        headerCartContainer.classList.remove('visible');
        
        // Force a reflow
        headerCartContainer.offsetHeight;
        
        // Start the animation
        requestAnimationFrame(() => {
            headerCartContainer.classList.add('transition-all', 'duration-500', 'ease-in');
            headerCartContainer.style.height = '0px';
            headerCartContainer.classList.remove('opacity-100', 'translate-y-0');
            headerCartContainer.classList.add('opacity-0', '-translate-y-4');
            
            // Clean up after animation
            setTimeout(() => {
                headerCartContainer.style.display = 'none';
                headerCartContainer.classList.remove('transition-all', 'duration-500', 'ease-in', 'duration-500', 'ease-out');
                headerCartContainer.style.height = '';
                headerCartContainer.style.overflow = '';
            }, 400);
        });
    }

    // Update header product details
    function updateHeaderProductDetails() {
        // Get product details from the main page
        const mainProductTitle = document.querySelector('.product-title, h1') || 
                                document.querySelector('[class*="product-title"]');
        const mainProductPrice = document.querySelector('.product-price .current-price, .price .current-price') || 
                                document.querySelector('[class*="current-price"]');
        const mainProductImage = document.getElementById('ProductPhotoImg') || 
                                document.querySelector('.main-image, [class*="main-image"]');
        
        // Header elements to update
        const headerTitle = document.getElementById('header-product-title');
        const headerPrice = document.getElementById('header-product-price');
        const headerImage = document.getElementById('header-product-img');
        const headerVariantInput = document.getElementById('header-variant-id');
        const headerButton = document.getElementById('header-add-to-cart-button');
        
        // Get current variant state from main product form
        const mainVariantInput = document.querySelector('product-info input[name="id"]') || 
                                document.querySelector('[id*="product-form"] input[name="id"]');
        const mainSubmitButton = document.querySelector('product-info button[type="submit"]') || 
                                document.querySelector('[id*="ProductSubmitButton"]');
        
        // Update title
        if (mainProductTitle && headerTitle) {
            headerTitle.textContent = mainProductTitle.textContent.trim();
        }
        
        // Update price
        if (mainProductPrice && headerPrice) {
            headerPrice.innerHTML = mainProductPrice.innerHTML;
        }
        
        // Update image
        if (mainProductImage && headerImage) {
            let imageSrc = mainProductImage.src;
            imageSrc = imageSrc.replace(/(_\d+x\d+|\?\w*=\d+x\d+|&\w*=\d+x\d+)/g, '');
            imageSrc += imageSrc.includes('?') ? '&width=160' : '?width=160';
            
            headerImage.src = imageSrc;
            headerImage.alt = mainProductImage.alt || '';
        }
        
        // Sync variant and button state
        if (mainVariantInput && headerVariantInput && mainSubmitButton && headerButton) {
            const currentVariantId = mainVariantInput.value;
            headerVariantInput.value = currentVariantId;
            
            const isDisabled = mainSubmitButton.hasAttribute('disabled') || 
                              mainSubmitButton.getAttribute('aria-disabled') === 'true';
            
            const headerButtonText = headerButton.querySelector('.btn-text');
            
            if (isDisabled || !currentVariantId) {
                headerButton.setAttribute('disabled', 'disabled');
                headerButton.setAttribute('aria-disabled', 'true');
                headerButtonText.textContent = mainSubmitButton.textContent.trim() || 'SOLD OUT';
                return false;
            } else {
                headerButton.removeAttribute('disabled');
                headerButton.removeAttribute('aria-disabled');
                headerButtonText.textContent = 'ADD TO CART';
                return true;
            }
        }
        
        // Sync quantity with main form
        const mainQuantity = document.querySelector('product-info .quantity__input') || 
                            document.querySelector('.quantity__input');
        const headerQuantity = document.getElementById('header-quantity');
        
        if (mainQuantity && headerQuantity) {
            headerQuantity.value = mainQuantity.value || '1';
            if (mainQuantity.min) headerQuantity.min = mainQuantity.min;
            if (mainQuantity.max) headerQuantity.max = mainQuantity.max;
        }
        
        return true;
    }

    // Sync header cart with main product form changes
    function setupProductFormSync() {
        const mainVariantInput = document.querySelector('product-info input[name="id"]') || 
                                document.querySelector('[id*="product-form"] input[name="id"]');
        const mainSubmitButton = document.querySelector('product-info button[type="submit"]') || 
                                document.querySelector('[id*="ProductSubmitButton"]');
        
        if (!mainVariantInput || !mainSubmitButton) {
            return;
        }
        
        // Watch for changes to main form elements
        const observer = new MutationObserver(() => {
            if (isHeaderCartVisible) {
                const isAvailable = updateHeaderProductDetails();
                if (!isAvailable) {
                    hideHeaderCart();
                    isHeaderCartVisible = false;
                }
            }
        });
        
        observer.observe(mainVariantInput, { attributes: true, attributeFilter: ['value'] });
        observer.observe(mainSubmitButton, { attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        
        // Listen for variant changes via PUB_SUB system
        if (typeof subscribe === 'function') {
            subscribe('variant-change', () => {
                setTimeout(() => {
                    if (isHeaderCartVisible) {
                        updateHeaderProductDetails();
                    }
                }, 100);
            });
        }
        
        // Listen for image changes from gallery
        const mainImage = document.getElementById('ProductPhotoImg');
        if (mainImage) {
            mainImage.addEventListener('image:changed', () => {
                if (isHeaderCartVisible) {
                    updateHeaderProductDetails();
                }
            });
        }
    }

    // Set up scroll listener with throttling
    function setupScrollListener() {
        let ticking = false;
        
        function handleScroll() {
            if (!ticking) {
                requestAnimationFrame(() => {
                    checkProductInfoVisibility();
                    ticking = false;
                });
                ticking = true;
            }
        }
        
        window.addEventListener('scroll', handleScroll, { passive: true });
        
        // Check initial state
        setTimeout(() => {
            checkProductInfoVisibility();
        }, 1000);
    }

    // Initialize everything
    setupProductFormSync();
    setupScrollListener();
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        setTimeout(initHeaderProductCart, 500);
    });
} else {
    setTimeout(initHeaderProductCart, 500);
}

// Backup initialization
setTimeout(() => {
    if (!document.querySelector('.header-add-to-cart[data-initialized]')) {
        initHeaderProductCart();
        document.querySelector('.header-add-to-cart')?.setAttribute('data-initialized', 'true');
    }
}, 2000);